// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import investigationHearingEntity from './entities/investigation-hearing.json';
import investigationHearingMenu from '../pages/investigation-hearing/menu.json';
import investigationHearingFullForm from '../pages/investigation-hearing/forms/full.json';
import investigationHearingContextForm from '../pages/investigation-hearing/forms/context.json';
import investigationHearingMiniForm from '../pages/investigation-hearing/forms/mini.json';
import investigationHearingLookupForm from '../pages/investigation-hearing/forms/lookup.json';
import investigationHearingTableView from '../pages/investigation-hearing/views/table.json';
import investigationHearingCardsView from '../pages/investigation-hearing/views/cards.json';
import investigationHearingDashboardView from '../pages/investigation-hearing/views/dashboard.json';

/** Тип запису «Слухання комісії» зі сторінками пакета: меню, форми та подання з pages/investigation-hearing/. */
export const investigationHearingDefinition: IRecordTypeDefinition = {
  ...investigationHearingEntity,
  views: assembleViewSet({
      table: investigationHearingTableView,
      cards: investigationHearingCardsView,
      dashboard: investigationHearingDashboardView,
  }),
  form: investigationHearingFullForm,
  forms: { full: investigationHearingFullForm, context: investigationHearingContextForm, mini: investigationHearingMiniForm, lookup: investigationHearingLookupForm },
  menu: investigationHearingMenu,
} as IRecordTypeDefinition;
